import {
  Button,
  Modal,
  ModalContent,
  ModalActions,
  ModalHeader,
  Table,
  TableRow,
  TableCell,
} from 'semantic-ui-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadMokaConfigLogs } from 'state/mokaConfig/actions';
import { parseISO } from 'date-fns';
import { formatDateTime } from '../../utils/dateTimeUtils';
import DefaultPagination from '../../components/DefaultPagination';

function MokaConfigLogModal() {
  const dispatch = useDispatch();
  const { mokaConfigLogs } = useSelector(state => state.config);
  const [open, setOpen] = React.useState(false);

  const logs = mokaConfigLogs.data.internal_tools_activities;
  const logPaging = mokaConfigLogs.paging;

  const fetchLogs = page => {
    const param = {
      page,
      size: 10,
    };
    dispatch(loadMokaConfigLogs(param));
  };

  const onPageChange = (event, { activePage }) => {
    fetchLogs(activePage);
  };

  const openModal = () => {
    fetchLogs(1);
    setOpen(true);
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={openModal}
      open={open}
      trigger={<Button>Logs</Button>}
    >
      <ModalHeader>Moka Configuration Logs</ModalHeader>
      <ModalContent>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Time</Table.HeaderCell>
              <Table.HeaderCell>Logs</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {logs.map(log => (
              <TableRow key={log.id}>
                <TableCell>{formatDateTime(parseISO(log.time))}</TableCell>
                <TableCell>{log.log}</TableCell>
              </TableRow>
            ))}
          </Table.Body>
        </Table>
        <DefaultPagination
          totalCount={logPaging.total}
          activePage={logPaging.page}
          pageSize={logPaging.size}
          onPageChange={onPageChange}
        />
      </ModalContent>
      <ModalActions>
        <Button onClick={() => setOpen(false)}>Close</Button>
      </ModalActions>
    </Modal>
  );
}

export default MokaConfigLogModal;
